import * as React from 'react';

import classnames from 'classnames';

type CtaBoxTextProps = {
  children?: React.ReactNode | string;
  color?: 'default' | 'inverse' | 'brand';
};

const CtaBoxText: React.FC<CtaBoxTextProps> = ({ children, color = 'default' }) => {
  const className = classnames({
    'cta-box__text': true,
    [`color-${color}`]: color,
  });

  return (
    <div className={className} data-qa="cta-box-text">
      {children}
    </div>
  );
};

export default CtaBoxText;
